import { Row } from 'blocks/CommonLayout';
import Loading from 'components/Loading';
import { Link } from 'react-router-dom';
import { ButtonProps, ButtonWrapperProps } from './button.interface';
import * as S from './button.styles';

// Button

const Button = ({
  className = '',
  onClick,
  loading = false,
  children,
  type = 'button',
  href = '/',
  color = 'info',
  disabled,
  fullWidth,
  width = null,
  iconEnd,
  iconStart,
  iconButton = false,
  size = 'medium',
  circular,
  style,
}: ButtonProps) =>
  loading ? (
    <S.Button
      $buttonColor={color}
      $disabled={disabled}
      className={`styled-button ${className}`}
      $width={width}
      $iconButton={iconButton}
      $size={size}
      $circular={circular}
      $isLink={type === 'link'}
    >
      <Loading size="small" fullScreen={false} color={color === 'outlined' ? '#588AF0' : '#fff'} />
    </S.Button>
  ) : type === 'link' ? (
    <S.Button
      $buttonColor={color}
      $disabled={disabled}
      className={`styled-button ${className}`}
      $width={width}
      $iconButton={iconButton}
      $size={size}
      $circular={circular}
      $isLink={type === 'link'}
    >
      <Link to={href || ''}>
        {iconStart && <S.IconStart $size={size}>{iconStart}</S.IconStart>}
        <span>{children}</span>
        {iconEnd && <S.IconEnd $size={size}>{iconEnd}</S.IconEnd>}
      </Link>
    </S.Button>
  ) : (
    <S.Button
      $buttonColor={color}
      className={`styled-button ${className}`}
      $disabled={disabled}
      onClick={onClick}
      $width={width}
      $iconButton={iconButton}
      $size={size}
      $circular={circular}
    >
      <Row justify="center" align="center" className="button-content">
        {iconStart && <S.IconStart $size={size}>{iconStart}</S.IconStart>}
        <span className="text">{children}</span>
        {iconEnd && <S.IconEnd $size={size}>{iconEnd}</S.IconEnd>}
      </Row>
    </S.Button>
  );

// Button wrapper

const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  justify = 'flex-end',
  children,
  className = '',
  topSpace = 'medium',
}) => (
  <S.BtnWrrapper $justify={justify} className={className} $topSpace={topSpace}>
    <Row justify={justify}>{children}</Row>
  </S.BtnWrrapper>
);

export default Button;
export { ButtonWrapper };
